import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "v1001",
    title: "办公室摸鱼大赏：老板突然推门的瞬间",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "搞笑",
    region: "中国大陆",
    year: 2024,
    duration: "02:15",
    author: "阿柴同学",
    uploadDate: "2024-09-28",
    likes: 12800,
    comments: 860,
    views: 320000,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20young%20office%20worker%20grinning%20at%20a%20bright%20modern%20desk%20warm%20natural%20office%20lighting%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-s-01&orientation=landscape",
    description:
      "记录办公室里各种摸鱼名场面，从假装忙碌到老板突然推门，每一个镜头都让人会心一笑。短短两分钟，带你看遍打工人的真实日常。",
    tags: ["办公室", "搞笑", "打工人"],
  },
  {
    id: "v1002",
    title: "当我把早餐做成餐厅的样子",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "美食",
    region: "中国大陆",
    year: 2024,
    duration: "03:40",
    author: "小鹿厨房",
    uploadDate: "2024-09-26",
    likes: 9600,
    comments: 420,
    views: 210000,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20breakfast%20plate%20styled%20like%20a%20fine%20restaurant%20on%20a%20bright%20wooden%20table%20soft%20morning%20light%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20food%20photography&width=640&height=360&seq=cv-s-02&orientation=landscape",
    description:
      "把家常早餐摆盘成餐厅出品，从煎蛋到摆盘技巧，一步步教你做出高颜值早餐。原来平凡的早晨也可以很有仪式感。",
    tags: ["美食", "早餐", "教程"],
  },
  {
    id: "v1003",
    title: "周末露营的一天｜治愈系生活记录",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "生活",
    region: "中国大陆",
    year: 2024,
    duration: "04:50",
    author: "果子Vlog",
    uploadDate: "2024-09-24",
    likes: 7300,
    comments: 210,
    views: 158000,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20weekend%20camping%20tent%20in%20a%20green%20meadow%20with%20soft%20afternoon%20sunlight%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20lifestyle%20photography&width=640&height=360&seq=cv-s-03&orientation=landscape",
    description:
      "一个人去露营的完整记录，搭帐篷、煮咖啡、看日落。没有多余的情节，只有安静的风景和治愈的时光。",
    tags: ["露营", "生活记录", "治愈"],
  },
  {
    id: "v1004",
    title: "猫咪第一次见到雪，反应太真实了",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "生活",
    region: "中国大陆",
    year: 2024,
    duration: "01:38",
    author: "毛球日记",
    uploadDate: "2024-09-22",
    likes: 21000,
    comments: 1500,
    views: 560000,
    cover:
      "https://readdy.ai/api/search-image?query=Curious%20fluffy%20cat%20pawing%20at%20fresh%20white%20snow%20on%20a%20bright%20winter%20day%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-s-04&orientation=landscape",
    description:
      "带家里的猫第一次出门看雪，从好奇到兴奋再到一脸茫然，每一个表情都被清晰记录下来。结尾的反应让人笑出声。",
    tags: ["萌宠", "猫咪", "治愈"],
  },
  {
    id: "v1005",
    title: "十块钱挑战：夜市能吃到什么",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "美食",
    region: "中国台湾",
    year: 2023,
    duration: "06:12",
    author: "甜辣酱",
    uploadDate: "2024-09-20",
    likes: 15400,
    comments: 980,
    views: 380000,
    cover:
      "https://readdy.ai/api/search-image?query=Bustling%20night%20market%20food%20stall%20with%20colorful%20warm%20lights%20and%20steaming%20snacks%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20food%20photography&width=640&height=360&seq=cv-s-05&orientation=landscape",
    description:
      "只带十块钱逛夜市，从街头吃到街尾，看看究竟能买到多少好吃的。真实又热闹的夜市烟火气扑面而来。",
    tags: ["美食", "夜市", "挑战"],
  },
  {
    id: "v1006",
    title: "校园里那些让人笑出声的名场面",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "搞笑",
    region: "中国大陆",
    year: 2023,
    duration: "03:05",
    author: "搞笑研究所",
    uploadDate: "2024-09-18",
    likes: 18200,
    comments: 1200,
    views: 470000,
    cover:
      "https://readdy.ai/api/search-image?query=Lively%20students%20laughing%20together%20on%20a%20sunny%20school%20campus%20field%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-s-06&orientation=landscape",
    description:
      "盘点校园生活中那些让人忍俊不禁的瞬间，从课堂尴尬到宿舍日常，满满的青春回忆杀，看完只想说一句：太真实了。",
    tags: ["校园", "搞笑", "青春"],
  },
  {
    id: "v1007",
    title: "一个人住的第100天｜极简出租屋改造",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "生活",
    region: "中国大陆",
    year: 2024,
    duration: "07:20",
    author: "住艺日记",
    uploadDate: "2024-09-16",
    likes: 6400,
    comments: 320,
    views: 132000,
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20cozy%20small%20rental%20apartment%20interior%20with%20wooden%20furniture%20soft%20daylight%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20interior%20photography&width=640&height=360&seq=cv-s-07&orientation=landscape",
    description:
      "用一百天把一间普通出租屋改造成理想的小家，从收纳、灯光到软装搭配，分享每一个实用又省钱的改造细节。",
    tags: ["家居", "改造", "生活"],
  },
  {
    id: "v1008",
    title: "深夜食堂：一碗治愈的番茄牛腩面",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "美食",
    region: "中国大陆",
    year: 2024,
    duration: "05:05",
    author: "面点小馆",
    uploadDate: "2024-09-14",
    likes: 8900,
    comments: 470,
    views: 186000,
    cover:
      "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20tomato%20beef%20noodle%20soup%20on%20a%20dark%20wooden%20table%20warm%20cozy%20lighting%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20food%20photography&width=640&height=360&seq=cv-s-08&orientation=landscape",
    description:
      "深夜为自己煮一碗番茄牛腩面，汤浓味足、面条劲道。全程无剪辑分步讲解，看完就想立刻下厨房。",
    tags: ["美食", "深夜食堂", "面条"],
  },
  {
    id: "v1009",
    title: "用一百种方式打开同一句话",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "搞笑",
    region: "中国大陆",
    year: 2024,
    duration: "02:48",
    author: "段子手阿宽",
    uploadDate: "2024-09-12",
    likes: 11200,
    comments: 640,
    views: 264000,
    cover:
      "https://readdy.ai/api/search-image?query=Expressive%20young%20man%20acting%20out%20different%20emotions%20in%20a%20bright%20studio%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-s-09&orientation=landscape",
    description:
      "同一句话用一百种情绪和方式说出来，从温柔到暴躁无缝切换。表演夸张又好笑，堪称行走的表情包。",
    tags: ["搞笑", "表演", "段子"],
  },
  {
    id: "v1010",
    title: "城市骑行｜清晨六点的街道",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "生活",
    region: "日本",
    year: 2023,
    duration: "04:20",
    author: "骑行笔记",
    uploadDate: "2024-09-10",
    likes: 5200,
    comments: 180,
    views: 96000,
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20empty%20city%20street%20at%20sunrise%20with%20a%20bicycle%20and%20soft%20golden%20light%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20photography&width=640&height=360&seq=cv-s-10&orientation=landscape",
    description:
      "清晨六点骑车穿过刚刚苏醒的城市，没有车水马龙，只有安静的街道和第一缕阳光。适合戴上耳机慢慢看。",
    tags: ["骑行", "城市", "生活"],
  },
  {
    id: "v1011",
    title: "挑战全网最辣的火鸡面",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "美食",
    region: "韩国",
    year: 2023,
    duration: "03:30",
    author: "吃货小满",
    uploadDate: "2024-09-08",
    likes: 13600,
    comments: 890,
    views: 340000,
    cover:
      "https://readdy.ai/api/search-image?query=Spicy%20red%20fire%20noodles%20in%20a%20bowl%20with%20chopsticks%20on%20a%20bright%20table%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20food%20photography&width=640&height=360&seq=cv-s-11&orientation=landscape",
    description:
      "挑战传说中最辣的火鸡面，从自信满满到泪流满面只用了三分钟。真实反应全程无剪，辣度警告请谨慎模仿。",
    tags: ["美食", "挑战", "辣"],
  },
  {
    id: "v1012",
    title: "看完这个视频，你再也不会怕蚊子了",
    categorySlug: "short-video",
    categoryName: "短视频",
    subCategory: "搞笑",
    region: "中国大陆",
    year: 2024,
    duration: "02:02",
    author: "冷知识君",
    uploadDate: "2024-09-06",
    likes: 9900,
    comments: 560,
    views: 228000,
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20illustrated%20scene%20of%20a%20tiny%20cartoon%20mosquito%20near%20a%20bright%20bedroom%20window%20at%20night%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-s-12&orientation=landscape",
    description:
      "用轻松幽默的方式科普蚊子为什么总盯着你，看完不仅涨知识，还莫名觉得这些小家伙有点好笑。",
    tags: ["冷知识", "搞笑", "科普"],
  },
  {
    id: "v2001",
    title: "《暗夜追光》超燃动作短片",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "动作",
    region: "中国大陆",
    year: 2024,
    duration: "01:32:00",
    author: "星驰影业",
    uploadDate: "2024-09-27",
    likes: 24000,
    comments: 1800,
    views: 680000,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20night%20city%20rooftop%20scene%20with%20a%20lone%20silhouette%20and%20warm%20street%20lights%20cinematic%20moody%20lighting%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-01&orientation=landscape",
    description:
      "一名普通快递员在深夜意外卷入一场追逐战，凭借过人的应变能力在霓虹街头展开生死博弈。节奏紧凑，动作戏全程高能。",
    tags: ["动作", "都市", "悬疑"],
  },
  {
    id: "v2002",
    title: "《山海归途》奇幻冒险预告",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "科幻",
    region: "中国大陆",
    year: 2024,
    duration: "01:45:00",
    author: "云帆影业",
    uploadDate: "2024-09-25",
    likes: 19800,
    comments: 1340,
    views: 520000,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20with%20floating%20mountains%20and%20golden%20mist%20cinematic%20sweeping%20view%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-02&orientation=landscape",
    description:
      "少年为寻找失踪的姐姐，踏入传说中的山海秘境，一路结识伙伴、破解谜题。奇幻世界观宏大，视效惊艳。",
    tags: ["奇幻", "冒险", "科幻"],
  },
  {
    id: "v2003",
    title: "《最后一班地铁》都市悬疑",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "动作",
    region: "中国香港",
    year: 2023,
    duration: "01:28:00",
    author: "银河映画",
    uploadDate: "2024-09-23",
    likes: 22300,
    comments: 1620,
    views: 610000,
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20late%20night%20subway%20platform%20with%20warm%20overhead%20lights%20cinematic%20suspenseful%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-03&orientation=landscape",
    description:
      "末班地铁上，一名乘客发现车厢里少了一个人，而监控却记录着他一直存在。层层反转的都市悬疑，结局出人意料。",
    tags: ["悬疑", "都市", "反转"],
  },
  {
    id: "v2004",
    title: "《家有囧事》爆笑家庭喜剧",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "喜剧",
    region: "中国大陆",
    year: 2024,
    duration: "01:36:00",
    author: "欢乐城堡",
    uploadDate: "2024-09-21",
    likes: 17600,
    comments: 1120,
    views: 420000,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cheerful%20family%20living%20room%20scene%20with%20cozy%20sofa%20and%20soft%20daylight%20comedy%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-04&orientation=landscape",
    description:
      "拆迁款到手后，一家三代人为了怎么花这笔钱闹出一连串啼笑皆非的故事。笑点密集，也藏着亲情的温度。",
    tags: ["喜剧", "家庭", "搞笑"],
  },
  {
    id: "v2005",
    title: "《星尘之约》科幻爱情巨制",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "科幻",
    region: "美国",
    year: 2024,
    duration: "02:10:00",
    author: "星尘工作室",
    uploadDate: "2024-09-19",
    likes: 30100,
    comments: 2400,
    views: 880000,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20starry%20night%20sky%20with%20a%20glowing%20distant%20planet%20cinematic%20dreamy%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-05&orientation=landscape",
    description:
      "两名相隔光年的宇航员通过一段延迟二十年的信号保持联系，时间的错位让他们的思念愈发浓烈。科幻外壳下的深情之作。",
    tags: ["科幻", "爱情", "催泪"],
  },
  {
    id: "v2006",
    title: "《山城往事》年代剧情片",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "动作",
    region: "中国大陆",
    year: 2022,
    duration: "01:50:00",
    author: "长江影业",
    uploadDate: "2024-09-17",
    likes: 12000,
    comments: 760,
    views: 280000,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20mountain%20city%20alley%20with%20warm%20evening%20lanterns%20cinematic%20retro%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-06&orientation=landscape",
    description:
      "上世纪九十年代，三个从小一起长大的兄弟在山城打拼，友情在时代洪流中历经考验。质朴真实，充满年代质感。",
    tags: ["剧情", "年代", "友情"],
  },
  {
    id: "v2007",
    title: "《笑到最后的邻居》爆笑喜剧",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "喜剧",
    region: "韩国",
    year: 2023,
    duration: "01:42:00",
    author: "首尔制片",
    uploadDate: "2024-09-15",
    likes: 14900,
    comments: 950,
    views: 360000,
    cover:
      "https://readdy.ai/api/search-image?query=Two%20neighboring%20apartment%20balconies%20with%20plants%20and%20warm%20daylight%20comedic%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-07&orientation=landscape",
    description:
      "楼上楼下两户邻居因为噪音结下梁子，从此展开一场又一场幼稚又搞笑的暗中较量。笑料不断，结尾却格外暖心。",
    tags: ["喜剧", "邻里", "搞笑"],
  },
  {
    id: "v2008",
    title: "《末日信标》硬核科幻",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "科幻",
    region: "美国",
    year: 2023,
    duration: "02:05:00",
    author: "信标影业",
    uploadDate: "2024-09-13",
    likes: 26400,
    comments: 1980,
    views: 740000,
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20abandoned%20space%20station%20corridor%20with%20warm%20emergency%20lights%20cinematic%20tense%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-08&orientation=landscape",
    description:
      "末日之后，一名工程师独自留守空间站等待救援信号。当信标终于亮起，他却发现来的并不是人类。硬核科幻设定，氛围拉满。",
    tags: ["科幻", "末日", "悬疑"],
  },
  {
    id: "v2009",
    title: "《拳台之上》热血运动片",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "动作",
    region: "中国大陆",
    year: 2024,
    duration: "01:55:00",
    author: "擂台影业",
    uploadDate: "2024-09-11",
    likes: 16700,
    comments: 1080,
    views: 400000,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20boxing%20ring%20under%20warm%20spotlights%20with%20sweat%20and%20energy%20cinematic%20intense%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-09&orientation=landscape",
    description:
      "一位被伤病困扰的前拳王重返擂台，为兑现对女儿的承诺拼上最后一战。训练蒙太奇与比赛场面热血沸腾。",
    tags: ["运动", "热血", "励志"],
  },
  {
    id: "v2010",
    title: "《外卖奇遇记》小人物喜剧",
    categorySlug: "net-movie",
    categoryName: "网络电影",
    subCategory: "喜剧",
    region: "中国大陆",
    year: 2024,
    duration: "01:38:00",
    author: "烟火电影",
    uploadDate: "2024-09-09",
    likes: 13800,
    comments: 890,
    views: 330000,
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20city%20street%20with%20a%20food%20delivery%20scooter%20and%20warm%20evening%20lights%20comedic%20warm%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20film%20poster%20style&width=640&height=360&seq=cv-n-10&orientation=landscape",
    description:
      "外卖小哥在一个雨夜接连遇到三件怪事，原本平凡的一天变成了一场城市奇遇。小人物的喜剧，笑中带泪。",
    tags: ["喜剧", "小人物", "温暖"],
  },
  {
    id: "v3001",
    title: "《向往的山野》明星田园真人秀",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "真人秀",
    region: "中国大陆",
    year: 2024,
    duration: "58:20",
    author: "山野传媒",
    uploadDate: "2024-09-29",
    likes: 20500,
    comments: 1420,
    views: 560000,
    cover:
      "https://readdy.ai/api/search-image?query=Idyllic%20countryside%20farmhouse%20with%20green%20fields%20and%20warm%20afternoon%20sunlight%20relaxing%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-01&orientation=landscape",
    description:
      "几位明星来到山谷里的小院，种菜、做饭、聊天，记录慢下来的生活。没有剧本冲突，只有真实的相处与欢笑。",
    tags: ["真人秀", "田园", "慢综艺"],
  },
  {
    id: "v3002",
    title: "《歌手对决》高音巅峰现场",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "音乐",
    region: "中国大陆",
    year: 2024,
    duration: "45:10",
    author: "声浪文化",
    uploadDate: "2024-09-28",
    likes: 31200,
    comments: 2650,
    views: 920000,
    cover:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20a%20microphone%20and%20warm%20golden%20spotlights%20energetic%20live%20music%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-02&orientation=landscape",
    description:
      "八位实力歌手同台飙歌，从抒情到高音全程高能。本场冠军用一首改编曲惊艳全场，现场观众集体起立。",
    tags: ["音乐", "现场", "竞演"],
  },
  {
    id: "v3003",
    title: "《深夜谈话室》与演员聊表演",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "访谈",
    region: "中国大陆",
    year: 2024,
    duration: "52:40",
    author: "星语文化",
    uploadDate: "2024-09-26",
    likes: 8700,
    comments: 520,
    views: 180000,
    cover:
      "https://readdy.ai/api/search-image?query=Intimate%20late%20night%20talk%20show%20set%20with%20warm%20lamps%20and%20a%20single%20chair%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-03&orientation=landscape",
    description:
      "在一间温暖的小屋里，与资深演员聊表演、聊人生、聊那些镜头背后不为人知的故事。安静的对话，真诚动人。",
    tags: ["访谈", "表演", "对话"],
  },
  {
    id: "v3004",
    title: "《荒野生存挑战》极限体能真人秀",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "真人秀",
    region: "英国",
    year: 2023,
    duration: "1:02:30",
    author: "极限制作",
    uploadDate: "2024-09-24",
    likes: 19400,
    comments: 1360,
    views: 480000,
    cover:
      "https://readdy.ai/api/search-image?query=Rugged%20wilderness%20cliff%20at%20dusk%20with%20warm%20orange%20sky%20adventurous%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-04&orientation=landscape",
    description:
      "十位选手被投放到无人荒野，仅凭有限的工具生存七天。极限环境下的合作与对抗，考验着每个人的意志。",
    tags: ["真人秀", "极限", "挑战"],
  },
  {
    id: "v3005",
    title: "《乐队夏天》独立音乐现场",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "音乐",
    region: "中国大陆",
    year: 2023,
    duration: "40:15",
    author: "声浪文化",
    uploadDate: "2024-09-22",
    likes: 24100,
    comments: 1880,
    views: 640000,
    cover:
      "https://readdy.ai/api/search-image?query=Indie%20band%20performing%20on%20a%20warm%20lit%20stage%20with%20guitars%20and%20drums%20energetic%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-05&orientation=landscape",
    description:
      "六支独立乐队轮番登台，用最原始的声音点燃夏夜。本期压轴乐队的现场版本在网络上引发大量讨论。",
    tags: ["音乐", "乐队", "现场"],
  },
  {
    id: "v3006",
    title: "《笑声工厂》脱口秀专场",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "真人秀",
    region: "中国大陆",
    year: 2024,
    duration: "55:00",
    author: "笑厂文化",
    uploadDate: "2024-09-20",
    likes: 17300,
    comments: 1190,
    views: 410000,
    cover:
      "https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20a%20microphone%20stand%20and%20warm%20spotlight%20playful%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-06&orientation=landscape",
    description:
      "八位脱口秀演员带来今年最密集的段子，从生活琐事到职场吐槽，全程零冷场。建议观看时不要喝水。",
    tags: ["脱口秀", "搞笑", "综艺"],
  },
  {
    id: "v3007",
    title: "《钢琴家的一天》专访纪录片",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "访谈",
    region: "德国",
    year: 2022,
    duration: "48:30",
    author: "古典之声",
    uploadDate: "2024-09-18",
    likes: 6900,
    comments: 410,
    views: 140000,
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20piano%20in%20a%20warm%20sunlit%20concert%20hall%20elegant%20calm%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-07&orientation=landscape",
    description:
      "跟随一位钢琴家度过平凡又充实的一天，从清晨练琴到深夜演出，展现古典音乐人真实而专注的日常。",
    tags: ["纪录片", "音乐", "人物"],
  },
  {
    id: "v3008",
    title: "《海岛度假日记》治愈慢综艺",
    categorySlug: "variety",
    categoryName: "娱乐综艺",
    subCategory: "真人秀",
    region: "泰国",
    year: 2024,
    duration: "1:05:20",
    author: "慢生活传媒",
    uploadDate: "2024-09-16",
    likes: 15900,
    comments: 1020,
    views: 380000,
    cover:
      "https://readdy.ai/api/search-image?query=Tropical%20island%20beach%20at%20golden%20sunset%20with%20palm%20trees%20and%20calm%20sea%20relaxing%20mood%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=360&seq=cv-v-08&orientation=landscape",
    description:
      "四位嘉宾来到海岛度过悠闲的假期，赶海、浮潜、看日落。没有任务和比赛，只有海风和慢下来的时光。",
    tags: ["真人秀", "海岛", "治愈"],
  },
];